<template lang="pug">
	.tags(v-if="shouldTagsBeShown()")
		.tags__inner
			SearchFilterTagsItem(
				v-for="item in selectedFilters", 
				:item="item", 
				:key="item.id",
				@removefilter="submitFilters")
			button.tags__clear(
				v-if="selectedFilters.length > 0" 
				@click="clearAll" 
				type="button") Clear All
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import SearchFilterTagsItem from './SearchFiltersTagsItem.vue'
export default {
	name: 'SearchFilterTags',
	components: {
		SearchFilterTagsItem
	},
	computed: {
		...mapGetters(["searchQuery", "results"]),
		selectedFilters() {
			return this.results.filters.reduce((selectedFilters, filterGroup) => {
				let groupID = filterGroup.id;
				let selectedInGroup = filterGroup.filters.filter(filter => filter.selected).map(selectedFilter => {
					return {...selectedFilter, groupID}
				});
				selectedFilters = [...selectedFilters, ...selectedInGroup];
				return selectedFilters;
			}, []);
		}
	},
	methods: {
    ...mapMutations(['setFilterItem']),
		submitFilters(data) {
			this.setFilterItem(data);
			this.$emit("submitfilters", this.getFilterQuerystring());
		},
		shouldTagsBeShown() {
			return this.selectedFilters.length > 0;
		},
		getFilterQuerystring() {
			const ids = [];
			this.searchQuery.filters.forEach((parent) => {
				const group = parent.filters
					.filter((c) => c.selected == true)
					.map((a) => a.id);

				if (group.length > 0) {
					ids.push(group);
				}
			});
			return ids.join(",");
		},
		clearAll() {
			this.selectedFilters.forEach(item => {
				const data = {
					groupID: item.groupID,
					id: item.id,
					value: false
				};
				this.setFilterItem(data);
			});
			this.$emit("submitfilters", this.getFilterQuerystring());
		}
	}
}
</script>

<style scoped lang="scss">
	.tags {
		position: relative;
		margin-bottom: 2rem;
		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			width: 4rem;
			height: 100%;
			background: $white;
			background: linear-gradient(90deg, rgba($white,0) 0%, rgba($white,1) 100%);
			pointer-events: none;
			z-index: 2;
		}
		&__inner {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding-right: 4rem;
			overflow-x: scroll;
			@include mq(md) {
				flex-wrap: wrap;
				overflow-x: none;
			}
		}
		&__clear {
			display: block;
			justify-self: end;
			flex: 1 1 max-content;
			margin: 0;
			padding: 0 1rem;
			background-color: transparent;
			border: 0;
			color: $blue;
			font-size: 0.875rem;
			font-weight: 200;
			white-space: nowrap;
			cursor: pointer;
			@include mq(md) {
				margin-bottom: 0.5rem;
			}
		}
	}
</style>